module.exports = __webpack_public_path__ + "img/33.8d98b9b.png";